// Yönetim sayfaları (kullanıcılar, ekipler, araç izinleri, aktiviteler, API anahtarları,
// ayarlar, mail, şifre değiştirme) için ek çeviriler. i18n/extra/index.js birleştirir.
const admin = {
  tr: {
    adminUsers: {
      tabs: { all: "Tümü", active: "Aktif", inactive: "Pasif" },
      filters: {
        search: "Ad, e-posta, kullanıcı adı, sicil veya departman ara...",
        allRoles: "Tüm roller",
        allTeams: "Tüm ekipler",
        noTeam: "Ekibi olmayanlar",
        sort: "Sırala",
        sortNameAsc: "Ad (A → Z)",
        sortNameDesc: "Ad (Z → A)",
        sortTeam: "Ekip",
        sortQuota: "İzin bakiyesi (çoktan aza)",
      },
      emptyFiltered: "Bu görünümde kullanıcı yok.",
      rolesRequired: "En az bir rol seçili olmalı.",
    },
    adminTeams: {
      tabs: { all: "Tümü", withManager: "Yöneticisi olan", noManager: "Yöneticisiz" },
      search: "Ekip veya yönetici ara...",
      emptyFiltered: "Bu görünümde ekip yok.",
      members: "Üye sayısı",
      nameRequired: "Ekip adı zorunludur.",
    },
    adminTools: {
      granted: "verildi",
      revoked: "kaldırıldı",
      updateFailed: "Güncelleme başarısız.",
      tabs: { all: "Tümü", granted: "Açık izni olanlar", none: "Hiç erişimi olmayanlar" },
      search: "Ad, soyad, kullanıcı adı veya e-posta ara…",
      role: "Rol",
      allRoles: "Tüm roller",
      tool: "Araç",
      allTools: "Tüm araçlar",
      user: "Kullanıcı",
      autoByRole: "Rolü gereği otomatik erişir",
      emptyFiltered: "Kayıt bulunamadı.",
    },
    adminActivities: {
      retry: "Tekrar dene",
      tabs: { all: "Tümü" },
      showFilters: "Filtreleri göster",
      hideFilters: "Filtreleri gizle",
      presets: { today: "Bugün", last7: "Son 7 gün", last30: "Son 30 gün" },
    },
    adminKeys: {
      show: "Göster",
      hide: "Gizle",
      dismiss: "Kapat",
      tabs: { active: "Aktif", revoked: "İptal edilmiş", all: "Tümü" },
      search: "İsim, prefix veya yetki ara...",
      empty: "Bu görünümde anahtar yok.",
    },
    adminSettings: {
      retry: "Tekrar dene",
      errors: {
        number: "Geçerli bir sayı girin.",
        min: "En az {{min}} olabilir.",
        max: "En fazla {{max}} olabilir.",
      },
      fixErrors: "Lütfen işaretli alanlardaki hataları düzeltin.",
      tabs: { leave: "İzin kuralları", travel: "Harcırah", notifications: "Bildirimler" },
      travelNote: "Şehir içi görevler harcırahsızdır; bu tutarlar yalnızca yurt içi/yurt dışı seyahatlerde uygulanır.",
      saving: "Kaydediliyor…",
      unsaved: "Kaydedilmemiş değişiklikler var",
    },
    adminMail: {
      errors: {
        port: "Port 1-65535 arasında tam sayı olmalı.",
        email: "Geçerli bir e-posta adresi girin.",
      },
      fixErrors: "Lütfen işaretli alanlardaki hataları düzeltin.",
    },
    changePassword: {
      tooShort: "Parola en az {{min}} karakter olmalı.",
      sameAsOld: "Yeni parola mevcut parolayla aynı olamaz.",
      show: "Parolaları göster",
      saving: "Kaydediliyor…",
      strength: { 0: "", 1: "Zayıf", 2: "Orta", 3: "İyi", 4: "Güçlü" },
    },
  },
  en: {
    adminUsers: {
      tabs: { all: "All", active: "Active", inactive: "Inactive" },
      filters: {
        search: "Search name, email, username, registry no. or department...",
        allRoles: "All roles",
        allTeams: "All teams",
        noTeam: "No team",
        sort: "Sort",
        sortNameAsc: "Name (A → Z)",
        sortNameDesc: "Name (Z → A)",
        sortTeam: "Team",
        sortQuota: "Leave balance (high → low)",
      },
      emptyFiltered: "No users in this view.",
      rolesRequired: "At least one role must be selected.",
    },
    adminTeams: {
      tabs: { all: "All", withManager: "With manager", noManager: "No manager" },
      search: "Search team or manager...",
      emptyFiltered: "No teams in this view.",
      members: "Members",
      nameRequired: "Team name is required.",
    },
    adminTools: {
      granted: "granted",
      revoked: "revoked",
      updateFailed: "Update failed.",
      tabs: { all: "All", granted: "With explicit access", none: "No access" },
      search: "Search name, username or email…",
      role: "Role",
      allRoles: "All roles",
      tool: "Tool",
      allTools: "All tools",
      user: "User",
      autoByRole: "Has access automatically by role",
      emptyFiltered: "No records found.",
    },
    adminActivities: {
      retry: "Retry",
      tabs: { all: "All" },
      showFilters: "Show filters",
      hideFilters: "Hide filters",
      presets: { today: "Today", last7: "Last 7 days", last30: "Last 30 days" },
    },
    adminKeys: {
      show: "Show",
      hide: "Hide",
      dismiss: "Close",
      tabs: { active: "Active", revoked: "Revoked", all: "All" },
      search: "Search name, prefix or scope...",
      empty: "No keys in this view.",
    },
    adminSettings: {
      retry: "Retry",
      errors: {
        number: "Enter a valid number.",
        min: "Must be at least {{min}}.",
        max: "Must be at most {{max}}.",
      },
      fixErrors: "Please fix the highlighted fields.",
      tabs: { leave: "Leave rules", travel: "Per diem", notifications: "Notifications" },
      travelNote: "Intra-city assignments get no per diem; these amounts only apply to domestic/international trips.",
      saving: "Saving…",
      unsaved: "You have unsaved changes",
    },
    adminMail: {
      errors: {
        port: "Port must be an integer between 1 and 65535.",
        email: "Enter a valid email address.",
      },
      fixErrors: "Please fix the highlighted fields.",
    },
    changePassword: {
      tooShort: "Password must be at least {{min}} characters.",
      sameAsOld: "New password must differ from the current one.",
      show: "Show passwords",
      saving: "Saving…",
      strength: { 0: "", 1: "Weak", 2: "Fair", 3: "Good", 4: "Strong" },
    },
  },
};

export default admin;
